// assets/menu-guard.js
(() => {
  const boot = () => {
    const root = document.querySelector('.section-header');
    if (!root) return;

    const GUTTER = 8;
    const PANEL_SEL = '.header__submenu';

    // 直下のパネルだけ拾う（:scope が無ければフォールバック）
    const panelOf = (details) => {
      if (!details) return null;
      try {
        return details.querySelector(':scope > .header__submenu');
      } catch (e) {
        // :scope 非対応ブラウザ用フォールバック
        for (const el of details.children) {
          if (el.matches && el.matches('.header__submenu')) return el;
        }
        return null;
      }
    };

    const flipIfNeeded = (panel) => {
      if (!panel) return;
      panel.removeAttribute('data-side');
      const rect = panel.getBoundingClientRect();
      const overRight = rect.right > (window.innerWidth - GUTTER);
      const overLeft  = rect.left  < GUTTER;
      if (overRight && !overLeft) panel.setAttribute('data-side', 'left');
    };

    // open 直後に測る
    root.addEventListener('toggle', (e) => {
      const d = e.target;
      if (!(d instanceof HTMLDetailsElement)) return;
      const panel = panelOf(d);
      if (panel && d.open) requestAnimationFrame(() => flipIfNeeded(panel));
    }, true);




    // ホバーでも都度測る（3階層想定）
    root.addEventListener('pointerenter', (e) => {
      
      const d = e.target?.closest?.('details');
      if (!d) return;
      const panel = panelOf(d);
      if (panel) requestAnimationFrame(() => flipIfNeeded(panel));
    }, true);

    // リサイズで全パネル再判定
    window.addEventListener('resize', () => {
      root.querySelectorAll(PANEL_SEL).forEach(flipIfNeeded);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
